export default {
    terminatedWithRepair: [
        6,    // Störung: weiter mit Reparatur
        205   // ZÜS    : Beseitigung ZÜS Mängel
    ],
    scheduled: [
        200,  // ZÜS    : Prüfung geplant
        201,  // ZÜS    : Prüfung abwarten
        202,   // ZÜS    : Klärung Prüfungstermin
         33
    ],
    proceccingScheduled: 2,
    terminated: 5,
}